import React from "react";
import { useNewSubmitProduct } from "./useNewSubmitProduct";
import { Redirect } from "react-router";
import Loading from "../Loading";
import { Container, Row, Col } from "react-bootstrap";

const NewSubmitProduct = ({ formData }) => {
  const { loading } = useNewSubmitProduct({ formData });

  if (loading) {
    return (
      <Container>
        <Row>
          <Col>
            <Loading />
          </Col>
        </Row>
      </Container>
    );
  } else {
    return <Redirect to="/products" />;
  }

  // console.log("CodeDeploy form: ", formData);
  // console.log("Data Records: ", datarecords);
};

export default NewSubmitProduct;
